import {React, withRouter, uiConstants, Switch, Route, lockr, useEffect, observer, RouteComponentProps} from '@api'
import {nav} from '@stores'
import {Dashboard, PrivateRoute} from '@design-board/components'
import {GDPRComplianceCheck} from 'centric-ui-components'
import * as css from './CatalogRouting.css'

export const CatalogRouting : any = withRouter(observer<Partial<RouteComponentProps>>(function CatalogRouting(props) {
  const {match, location} = props ?? {}

  // update the nav store whenever the location/match changes
  useEffect(() => { nav.updateLocation(location, match) }, [location])

  return (
    <div className={css.root}>
      {false && <GDPRComplianceCheck/>}

      <Switch>
        <PrivateRoute path={`${match.path}`} component={Dashboard}/>
        <Route path='*'>
          <NotFoundPage/>
        </Route>
      </Switch>
    </div>
  )
}))

export const NotFoundPage = () => <div>404 page</div>




// WEBPACK FOOTER //
// ./src/modules/dashboard/CatalogRouting.tsx